import { Component, Input, OnInit } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-insurance-invoice',
  templateUrl: './insurance-invoice.component.html',
  styleUrls: ['./insurance-invoice.component.scss']
})
export class InsuranceInvoiceComponent implements OnInit {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  settings: any = null;
  logoUrl: string = '';

  bankName: string = 'MIZUHO BANK LTD.';
  branchName: string = 'KOBE BRANCH';
  accountName: string = 'IMPERIAL SOLUTIONS LTD.';
  accountNo: string = '490 0103234';
  swiftCode: string = 'MHCBJPJT';

  constructor(private _globalService: GlobalStateService) {}

  ngOnInit(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
      this.logoUrl = res.logo || '';
    });
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatMfgYear(year: string | null | undefined, month: string | null | undefined): string {
    if (!year) return '-';
    return month ? `${year}/${month.toString().padStart(2, '0')}` : year;
  }

  getUnitCount(invoice: Invoice): number {
    if (this.viewMode === 'merged' && invoice.vehicles) {
      return invoice.vehicles.length;
    }
    return 1;
  }
}
